import { useState } from 'react';

const initGraph = {
  labels: [],
  datasets: [],
};

export const useSolicitudCoberturaTramitesPorDelegacionBarra = ({ anualList = [], top = 10 }) => {
  const [datosIniciadasAnualesBarras, setDatosIniciadasAnualesBarras] = useState(initGraph);
  const [datosAutorizadasAnualesBarras, setDatosAutorizadasAnualesBarras] = useState(initGraph);

  const getDatosIniciadasAnualesBarras = () => {
    // Paso 1: agrupar por sede sumando las demoras por categoría
    const acumulado = anualList.reduce((acc, item) => {
      const sede = item.sede;
      if (!acc[sede]) {
        acc[sede] = {
          demora_0_3_dias: 0,
          demora_4_7_dias: 0,
          demora_mas_7_dias: 0,
          totalPendientes: 0
        };
      }
      acc[sede].demora_0_3_dias += item.demora_0_3_dias || 0;
      acc[sede].demora_4_7_dias += item.demora_4_7_dias || 0;
      acc[sede].demora_mas_7_dias += item.demora_mas_7_dias || 0;
      acc[sede].totalPendientes += (item.demora_0_3_dias || 0) + (item.demora_4_7_dias || 0) + (item.demora_mas_7_dias || 0);
      return acc;
    }, {});

    // Paso 2: convertir a array de objetos
    const arraySedes = Object.entries(acumulado).map(([sede, demoras]) => ({
      sede,
      ...demoras,
    }));

    // Paso 3: ordenar de mayor a menor por total de pendientes
    const result = arraySedes.sort((a, b) => b.totalPendientes - a.totalPendientes).slice(0, top);

    setDatosIniciadasAnualesBarras({
      labels: result.map((item) => item.sede),
      datasets: [
        {
          label: '7+ días',
          data: result.map((item) => item.demora_mas_7_dias),
          backgroundColor: 'rgba(244, 67, 54, 0.9)',
        },
        {
          label: '4-7 días',
          data: result.map((item) => item.demora_4_7_dias),
          backgroundColor: 'rgba(255, 193, 7, 0.9)',
        },
        {
          label: '0-3 días',
          data: result.map((item) => item.demora_0_3_dias),
          backgroundColor: 'rgba(76, 175, 80, 0.9)',
        },
      ],
    });
  };

  const getDatosAutorizadasAnualesBarras = () => {
    // Paso 1: agrupar por sede sumando los autorizados
    const acumulado = anualList.reduce((acc, item) => {
      const sede = item.sede;
      if (!acc[sede]) {
        acc[sede] = 0;
      }
      acc[sede] += item.cantidad_autorizados || 0; // acumulamos
      return acc;
    }, {});

    // Paso 2: convertir a array de objetos
    const arraySedes = Object.entries(acumulado).map(([sede, totalAutorizados]) => ({
      sede,
      totalAutorizados,
    }));

    // Paso 3: ordenar de mayor a menor
    const result = arraySedes.sort((a, b) => b.totalAutorizados - a.totalAutorizados).slice(0, top);

    setDatosAutorizadasAnualesBarras({
      labels: result.map((item) => item.sede),
      datasets: [
        {
          label: 'Autorizadas',
          data: result.map((item) => item.totalAutorizados),
          backgroundColor: 'rgba(53, 223, 235, 0.9)',
        },
      ],
    });
  };

  return {
    datosAutorizadasAnualesBarras,
    datosIniciadasAnualesBarras,
    getDatosAutorizadasAnualesBarras,
    getDatosIniciadasAnualesBarras,
  };
};
